<template>
    <div class="post" :class="view ? 'post-view' : ''" v-if="post">
        <div class="post-header">
            <div class="post-author-info">
                <div class="author-avatar" v-if="post.author">{{post.author[0]}}</div>
                <div class="author-info">
                    <div class="author">{{post.author}}</div>
                    <span v-if="view" class="divider" style="display: none">·</span>
                    <div class="info">
                        <span>{{post.ago}} ago</span>
                        <span class="divider">·</span>
                        <span>{{post.read}}</span>
                    </div>
                </div>
            </div>
            <div class="options">
                <icon-post-options />
            </div>
        </div>
        <div v-if="!isLinkable" class="post-body">
            <div class="post-title">{{post.title}}</div>
            <div class="post-content">
                <span v-if="thumbnail">
                    <text-truncate 
                        :content="content(post.contentHTML)"
                        :truncate="postContentTruncate"/>
                </span>
                <span v-else>
                    <span v-if="isHtmlContent" v-html="post.contentHTML"></span>
                    <span v-else>{{content(post.contentHTML)}}</span>
                </span>
            </div>
        </div>
        <router-link v-else :to="{name: 'PostView', params: {id: post.id}}" class="post-body">
            <div class="post-title">{{post.title}}</div>
            <div class="post-content">
                <span v-if="thumbnail">
                    <text-truncate 
                        :content="content(post.contentHTML)"
                        :truncate="postContentTruncate"/>
                </span>
                <span v-else>
                    <span v-if="isHtmlContent" v-html="post.contentHTML"></span>
                    <span v-else>{{content(post.contentHTML)}}</span>
                </span>
            </div>
        </router-link>
        <div class="post-footer">
            <div class="left">
                <div class="views">
                    <icon-post-views style="fill: #666" />
                    <span>{{post.views}}</span>
                </div>
                <div class="comment">
                    <a class="a-text" href="#">Write a comment</a>
                </div>
            </div>
            <div class="right">
                <div class="likes">
                    <span v-if="post.likes > 0">{{post.likes}}</span>
                    <a href="#!" style="display: inline-flex"
                        @click.prevent="like(post)">
                        <icon-post-unlike :class="post.youLikeIt ? 'like' : 'unlike'" />
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import TextTruncate from '@/components/TextTruncate.vue'
import IconPostOptions from '@/components/Icons/PostOptions.vue'
import IconPostViews from '@/components/Icons/PostViews.vue'
import IconPostUnlike from '@/components/Icons/PostUnlike.vue'

export default {
    name: 'post',
    props: ['post', 'type', 'postContentTruncate', 'isLinkable', 'isHtmlContent'],
    components: {
        TextTruncate,
        IconPostOptions,
        IconPostViews,
        IconPostUnlike
    },
    data() {
        return {
            
        }
    },
    computed: {
        thumbnail() {
            return this.type == 'thumbnail'
        },
        view() {
            return this.type == 'view'
        },
    },
    methods: {
        content(content) {
            var div = document.createElement("div");
            div.innerHTML = content;
            var text = div.textContent || div.innerText || "";
            return text
        },
        like(post) {
            if(!post.youLikeIt) {
                post.likes++
                post.youLikeIt = true
            } else {
                post.likes--
                post.youLikeIt = false
            }
        }
    }
}
</script>
